import {
  CHECKBOX_TYPE_ALLOWREAD,
  CHECKBOX_TYPE_ALLOWWRITE,
  CHECKBOX_TYPE_PREFERENCES,
} from './constants';
import { accessRowToFieldId } from './form';

/**
 * @param {Array} group
 * @param {Object} formValues
 * @param {String} type
 *
 * @return {Boolean}
 */
export const groupIsIndeterminate = (
  group = [],
  formValues = {},
  type = CHECKBOX_TYPE_ALLOWREAD
) => {
  const groupCount = groupTypeCount(group, formValues, type);

  return groupCount > 0 && groupCount !== group.length;
};

/**
 * @param {Array*} group
 * @param {Object} formValues
 * @param {String} type
 *
 * @return {Boolean}
 */
export const groupIsChecked = (
  group = [],
  formValues = {},
  type = CHECKBOX_TYPE_ALLOWREAD
) => {
  const groupCount = groupTypeCount(group, formValues, type);
  let compareValue = group.length;

  if (type === CHECKBOX_TYPE_ALLOWREAD)
    compareValue = group.filter(item => item.IsViewOnlyApplicable).length;

  return groupCount === compareValue || groupCount > compareValue;
};

/**
 * @param {Array} group
 * @param {Object} formValues
 * @param {String} type
 *
 * @return {Number}
 */
export const groupTypeCount = (
  group = [],
  formValues = {},
  type = CHECKBOX_TYPE_ALLOWREAD
) => {
  let groupCount = 0;

  group.forEach(item => {
    const Id = accessRowToFieldId(item);
    if (
      type === CHECKBOX_TYPE_ALLOWREAD &&
      formValues[`AllowRead${Id}`] !== undefined &&
      formValues[`AllowRead${Id}`]
    ) {
      groupCount++;
    }

    if (
      (type === CHECKBOX_TYPE_ALLOWWRITE ||
        type === CHECKBOX_TYPE_PREFERENCES) &&
      formValues[`AllowWrite${Id}`] !== undefined &&
      formValues[`AllowWrite${Id}`]
    ) {
      groupCount++;
    }
  });

  return groupCount;
};



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/helpers/checkbox.js